<template>
    <div class="good-page">
        <div class="container">
            <div class="handle-box">
                <div class="handle-box-left">
                    <el-input placeholder="请输入商品名称" v-model="title" class="search-input"></el-input>
                    <el-button type="primary" @click="handleSearch" icon="el-icon-search" :disabled="disfle"
                        :loading="lod">搜索
                    </el-button>
                </div>
                <div>
                    <el-button type="primary" @click="tian = true" icon="el-icon-plus">添加商品</el-button>
                </div>
            </div>
            <el-table :data="tableData" border class="table table-then-card" ref="filterTable" v-loading="loading" style="width: 100%">
                <el-table-column prop="title" label="商品标题" show-overflow-tooltip min-width="200"></el-table-column>
                <el-table-column prop="name" label="所属分类" show-overflow-tooltip align="center"
                    min-width="120"></el-table-column>
                <el-table-column label="商品图片(点击查看)" align="center" prop="imgList" width="200">
                    <template slot-scope="scope">
                        <el-image class="table-td-thumb" preview-teleported :src="scope.row.imgList[0]"
                            :preview-src-list="scope.row.imgList" :z-index="10">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="起步价(元)" width="120" align="center"></el-table-column>
                <el-table-column label="季节规格/颜色" min-width="180" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.seasonSpecs" style="font-size:12px;color:#909399;margin-bottom:4px;">
                            <el-tag v-for="(s, i) in parseJson(scope.row.seasonSpecs)" :key="i" size="mini" style="margin-right:4px;margin-bottom:2px;">{{ s.name }}</el-tag>
                        </div>
                        <div v-if="scope.row.colors" style="font-size:12px;color:#909399;">
                            <el-tag v-for="(c, i) in parseJson(scope.row.colors)" :key="i" size="mini" type="info" style="margin-right:4px;margin-bottom:2px;">{{ c }}</el-tag>
                        </div>
                        <div v-if="!scope.row.seasonSpecs && !scope.row.colors">-</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sales" label="商品销量" width="100" align="center" class-name="mobile-hide"></el-table-column>
                <el-table-column prop="isPutaway" label="是否上架" width="100" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.isPutaway == 1">
                            <el-tag effect="dark">
                                已上架
                            </el-tag>
                        </template>
                        <template v-if="scope.row.isPutaway == 0">
                            <el-tag effect="dark" type="danger">
                                未上架
                            </el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" min-width="180" class-name="mobile-hide"></el-table-column>
                <el-table-column prop="updateTime" label="修改时间" align="center" min-width="180" class-name="mobile-hide"></el-table-column>
                <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit-outline" style="color:green"
                            @click="handleUp(scope.$index, scope.row)">
                            修改
                        </el-button>
                        <el-button type="text" icon="el-icon-delete" style="color:#ff0000"
                            @click="handleDe(scope.$index, scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 手机端卡片列表 -->
            <div class="mobile-card-list" v-loading="loading">
                <div v-for="(row, idx) in tableData" :key="idx" class="mc-card">
                    <div class="mc-thumb-area">
                        <el-image class="mc-img" preview-teleported :src="row.imgList && row.imgList[0]"
                            :preview-src-list="row.imgList" :z-index="10" fit="cover"></el-image>
                        <div class="mc-thumb-info">
                            <div class="mc-title" style="margin-bottom:4px">{{ row.title }}</div>
                            <div style="font-size:12px;color:#909399;">{{ row.name }}</div>
                        </div>
                    </div>
                    <div class="mc-grid-2">
                        <div class="mc-row">
                            <span class="mc-label">起步价</span>
                            <span class="mc-value mc-value-danger">¥{{ row.price }}</span>
                        </div>
                        <div class="mc-row" v-if="row.seasonSpecs">
                            <span class="mc-label">季节规格</span>
                            <span class="mc-value">
                                <el-tag v-for="(s, i) in parseJson(row.seasonSpecs)" :key="i" size="mini" style="margin-right:4px;">{{ s.name }}</el-tag>
                            </span>
                        </div>
                        <div class="mc-row" v-if="row.colors">
                            <span class="mc-label">颜色</span>
                            <span class="mc-value">
                                <el-tag v-for="(c, i) in parseJson(row.colors)" :key="i" size="mini" type="info" style="margin-right:4px;">{{ c }}</el-tag>
                            </span>
                        </div>
                        <div class="mc-row">
                            <span class="mc-label">上架状态</span>
                            <span class="mc-value">
                                <el-tag v-if="row.isPutaway == 1" effect="dark" size="mini">已上架</el-tag>
                                <el-tag v-else effect="dark" type="danger" size="mini">未上架</el-tag>
                            </span>
                        </div>
                        <div class="mc-row">
                            <span class="mc-label">销量</span>
                            <span class="mc-value">{{ row.sales }}</span>
                        </div>
                    </div>
                    <div class="mc-actions">
                        <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="handleUp(idx, row)">修改</el-button>
                        <el-button size="small" type="danger" icon="el-icon-delete" @click="handleDe(idx, row)">删除</el-button>
                    </div>
                </div>
                <div v-if="!loading && tableData.length === 0" style="text-align:center;color:#909399;padding:30px 0;">暂无数据</div>
            </div>
            <div class="pagination">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="page" :page-size="size"
                    layout="total, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </div>


        <el-dialog title="添加商品" :visible.sync="tian" :width="dialogWidthSmall">
            <el-form label-position="left" :rules="rules" ref="obj" label-width="150px" :model="obj" status-icon>
                <el-form-item label="商品图片" prop="images">
                    <el-upload :before-upload="handleBeforeUpload" :action="this.$base.file" list-type="picture-card"
                        ref="upload" :auto-upload="true" :on-success="handleAvatarSuccess" :file-list="fileList">
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{file}">
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl">
                    </el-dialog>
                </el-form-item>
                <el-form-item label="商品标题" prop="title">
                    <el-input placeholder="请输入商品标题" prefix-icon="el-icon-edit" v-model="obj.title"></el-input>
                </el-form-item>
                <el-form-item label="商品分类" prop="cid">
                    <el-cascader v-model="cidPath" :options="cascaderOptions" placeholder="请选择分类" style="width: 100%;"></el-cascader>
                </el-form-item>
                <el-form-item label="商品起步价" prop="price">
                    <el-input-number v-model="obj.price" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item label="商品简介" prop="intro">
                    <el-input type="textarea" :rows="3" placeholder="请输入商品弹窗简介" v-model="obj.intro"></el-input>
                </el-form-item>
                <el-form-item label="季节性花束规格">
                    <div v-for="(s, idx) in obj.seasonSpecs" :key="idx" style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px;align-items:flex-start;">
                        <el-input v-model="s.name" placeholder="规格名称" size="small" style="flex:1;min-width:100px;"></el-input>
                        <el-input v-model.number="s.extraPrice" type="number" placeholder="规格价格(元)" size="small" style="width:110px;" @blur="s.extraPrice = Math.max(0.01, parseFloat(s.extraPrice) || 0)"></el-input>
                        <el-button type="danger" icon="el-icon-delete" size="small" circle @click="removeSeasonSpec(idx, false)" style="flex-shrink:0;"></el-button>
                        <el-input v-model="s.intro" type="textarea" :rows="2" placeholder="规格简介（纯文本）" size="small" style="flex:1;min-width:200px;"></el-input>
                    </div>
                    <el-button type="primary" plain size="small" icon="el-icon-plus" @click="addSeasonSpec(false)">添加规格</el-button>
                </el-form-item>
                <el-form-item label="花束颜色">
                    <div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:10px;">
                        <el-tag v-for="(c, idx) in obj.colors" :key="idx" closable @close="removeColor(idx, false)" style="margin-right:5px;">{{ c }}</el-tag>
                    </div>
                    <div style="display:flex;gap:8px;">
                        <el-input v-model="tempColorInput" placeholder="输入颜色名称" size="small" style="width:180px;" @keyup.enter.native="addColor(false)"></el-input>
                        <el-button type="primary" plain size="small" icon="el-icon-plus" @click="addColor(false)">添加</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="是否上架" prop="isPutaway">
                    <el-radio v-model="obj.isPutaway" :label="1">上架</el-radio>
                    <el-radio v-model="obj.isPutaway" :label="0">下架</el-radio>
                </el-form-item>
                <el-form-item label="商品详情" prop="details">
                    <editor style="min-width: 200px; max-width: 600px;" v-model="obj.details" class="editor" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subAdd('obj')">确 定</el-button>
                <el-button @click="tian = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改商品" :visible.sync="upg" :width="dialogWidthSmall">
            <el-form label-position="left" :rules="ruless" ref="upObj" label-width="150px" :model="upObj" status-icon>
                <el-form-item label="商品图片" prop="images">
                    <el-upload :before-upload="handleBeforeUpload" :action="this.$base.file" list-type="picture-card"
                        ref="upload" :auto-upload="true" :on-success="handleAvatarSuccess" :file-list="fileListU">
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{file}">
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl">
                    </el-dialog>
                </el-form-item>
                <el-form-item label="商品标题" prop="title">
                    <el-input placeholder="请输入商品标题" prefix-icon="el-icon-edit" v-model="upObj.title"></el-input>
                </el-form-item>
                <el-form-item label="商品分类" prop="cid">
                    <el-cascader v-model="upCidPath" :options="cascaderOptions" placeholder="请选择分类" style="width: 100%;"></el-cascader>
                </el-form-item>
                <el-form-item label="商品起步价" prop="price">
                    <el-input-number v-model="upObj.price" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item label="商品简介" prop="intro">
                    <el-input type="textarea" :rows="3" placeholder="请输入商品弹窗简介" v-model="upObj.intro"></el-input>
                </el-form-item>
                <el-form-item label="季节性花束规格">
                    <div v-for="(s, idx) in upObj.seasonSpecs" :key="idx" style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px;align-items:flex-start;">
                        <el-input v-model="s.name" placeholder="规格名称" size="small" style="flex:1;min-width:100px;"></el-input>
                        <el-input v-model.number="s.extraPrice" type="number" placeholder="规格价格(元)" size="small" style="width:110px;" @blur="s.extraPrice = Math.max(0.01, parseFloat(s.extraPrice) || 0)"></el-input>
                        <el-button type="danger" icon="el-icon-delete" size="small" circle @click="removeSeasonSpec(idx, true)" style="flex-shrink:0;"></el-button>
                        <el-input v-model="s.intro" type="textarea" :rows="2" placeholder="规格简介（纯文本）" size="small" style="flex:1;min-width:200px;"></el-input>
                    </div>
                    <el-button type="primary" plain size="small" icon="el-icon-plus" @click="addSeasonSpec(true)">添加规格</el-button>
                </el-form-item>
                <el-form-item label="花束颜色">
                    <div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:10px;">
                        <el-tag v-for="(c, idx) in upObj.colors" :key="idx" closable @close="removeColor(idx, true)" style="margin-right:5px;">{{ c }}</el-tag>
                    </div>
                    <div style="display:flex;gap:8px;">
                        <el-input v-model="tempColorInputU" placeholder="输入颜色名称" size="small" style="width:180px;" @keyup.enter.native="addColor(true)"></el-input>
                        <el-button type="primary" plain size="small" icon="el-icon-plus" @click="addColor(true)">添加</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="是否上架" prop="isPutaway">
                    <el-radio v-model="upObj.isPutaway" :label="1">上架</el-radio>
                    <el-radio v-model="upObj.isPutaway" :label="0">下架</el-radio>
                </el-form-item>
                <el-form-item label="商品详情" prop="details">
                    <editor style="min-width: 200px; max-width: 600px;" v-model="upObj.details" class="editor" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subUp('upObj')">确 定</el-button>
                <el-button @click="upg = false">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { queryClassifys, queryGoods, querySearchGoods, addGood, updateByGood, deleteByGood } from '@/api';
export default {
    name: "GoodAdm",
    data() {
        return {
            url: '',
            title: '',
            lod: false,
            disfle: true,
            loading: true,
            tableData: [],
            classifys: [],
            page: 1,
            size: 10,
            total: 0,
            upg: false,
            tian: false,
            dialogVisible: false,
            dialogImageUrl: '',
            fileList: [],
            fileListU: [],
            obj: {
                images: [],
                cid: '',
                title: '',
                price: '',
                intro: '',
                seasonSpecs: [],
                colors: [],
                isPutaway: 1,
                details: ''
            },
            upObj: {},
            // 颜色临时输入
            tempColorInput: '',
            tempColorInputU: '',
            cidPath: [],
            upCidPath: [],
            rules: {
                images: [
                    { required: true, message: "请上传商品图片", trigger: "blur" }
                ],
                title: [
                    { required: true, message: "商品标题不能为空", trigger: "blur" }
                ],
                cid: [
                    { required: true, message: "请选择商品分类", trigger: "change" }
                ],
                price: [
                    { required: true, message: "请输入价格", trigger: "blur" }
                ],
                intro: [],
                isPutaway: [],
                details: [
                    { required: true, message: "详情不能为空", trigger: "blur" }
                ]
            },
            ruless: {
                images: [
                    { required: true, message: "请上传商品图片", trigger: "blur" }
                ],
                title: [
                    { required: true, message: "商品标题不能为空", trigger: "blur" }
                ],
                cid: [
                    { required: true, message: "请选择商品分类", trigger: "change" }
                ],
                price: [
                    { required: true, message: "请输入价格", trigger: "blur" }
                ],
                intro: [],
                isPutaway: [],
                details: [
                    { required: true, message: "详情不能为空", trigger: "blur" }
                ]
            },


        };
    },
    computed: {
        dialogWidthSmall() {
            return window.innerWidth < 768 ? '95%' : '500px';
        },
        cascaderOptions() {
            const list = this.classifys || [];
            const parents = list.filter(c => !c.parentId || c.parentId === 0);
            return parents.map(p => {
                const children = list.filter(c => c.parentId === p.cid);
                if (children.length === 0) {
                    // 没有二级分类的一级分类不展示，强制必须选择二级分类
                    return null;
                }
                return {
                    value: p.cid,
                    label: p.name,
                    children: children.map(c => ({ value: c.cid, label: c.name }))
                };
            }).filter(item => item !== null);
        }
    },
    watch: {
        cidPath(val) {
            if (Array.isArray(val) && val.length > 0) {
                this.obj.cid = val[val.length - 1];
            }
        },
        upCidPath(val) {
            if (Array.isArray(val) && val.length > 0) {
                this.upObj.cid = val[val.length - 1];
            }
        },
        title: {
            handler(val) {
                if (val) {
                    this.disfle = false
                } else {
                    this.disfle = true;
                    this.page = 1;
                    this.total = 0;
                    this.getData();
                }
            }
        }
    },

    methods: {
        // 安全解析JSON
        parseJson(str) {
            if (!str) return [];
            try {
                return JSON.parse(str);
            } catch (e) {
                return [];
            }
        },
        // 判断上传的是否为图片
        handleBeforeUpload(file) {
            var img = file.name.substring(file.name.lastIndexOf('.') + 1)
            const suffix = img === 'jpg'
            const suffix2 = img === 'png'
            const suffix3 = img === 'jpeg'
            // const isLt1M = file.size / 1024 / 1024 < 1;
            if (!suffix && !suffix2 && !suffix3) {
                this.$message.error("只能上传图片！");
                return false
            }
            return suffix || suffix2 || suffix3
        },
        handleRemove(file, fileList) {
            const uploadFiles = this.$refs.upload.uploadFiles;
            for (let i in uploadFiles) {
                if (file.url === uploadFiles[i].url) {
                    uploadFiles.splice(i, 1);
                    if (this.upg) {
                        this.upObj.images.splice(i, 1);
                        this.fileListU.splice(i, 1);
                    } else {
                        this.obj.images.splice(i, 1);
                        this.fileList.splice(i, 1);
                    }
                }
            }

        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        //上传图：后端返回 { key: objectKey, url: 预签名URL }
        handleAvatarSuccess(res, file) {
            if (res.code != 0) {
                this.$message.error('上传失败')
            } else {
                const data = res.data || {};
                const key = data.key;
                const previewUrl = data.url;
                // 预览列表使用签名 URL
                file.url = previewUrl;
                if (this.upg) {
                    this.upObj.images.push(key);
                    this.fileListU.push({ url: previewUrl });
                } else {
                    this.obj.images.push(key);
                    this.fileList.push({ url: previewUrl });
                }
                this.$refs.upload.clearFiles()
            }
        },
        // 季节规格操作
        addSeasonSpec(isUpdate) {
            const target = isUpdate ? this.upObj : this.obj;
            if (!target.seasonSpecs) target.seasonSpecs = [];
            target.seasonSpecs.push({ name: '', extraPrice: 0, intro: '' });
        },
        removeSeasonSpec(index, isUpdate) {
            const target = isUpdate ? this.upObj : this.obj;
            if (target.seasonSpecs) target.seasonSpecs.splice(index, 1);
        },
        // 颜色操作
        addColor(isUpdate) {
            const target = isUpdate ? this.upObj : this.obj;
            const inputKey = isUpdate ? 'tempColorInputU' : 'tempColorInput';
            const val = this[inputKey].trim();
            if (!val) return;
            if (!target.colors) target.colors = [];
            if (!target.colors.includes(val)) {
                target.colors.push(val);
            }
            this[inputKey] = '';
        },
        removeColor(index, isUpdate) {
            const target = isUpdate ? this.upObj : this.obj;
            if (target.colors) target.colors.splice(index, 1);
        },
        // 提交前序列化数组字段
        _serializeGood(obj) {
            const copy = { ...obj };
            copy.images = JSON.stringify(copy.images);
            copy.seasonSpecs = copy.seasonSpecs && copy.seasonSpecs.length > 0 ? JSON.stringify(copy.seasonSpecs) : null;
            copy.colors = copy.colors && copy.colors.length > 0 ? JSON.stringify(copy.colors) : null;
            return copy;
        },
        //修改指定商品信息
        subUp(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定修改该商品信息?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = this._serializeGood(this.upObj);
                        updateByGood(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.upg = false;
                            this.$message.success(msg);
                            this.getData();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        //添加商品
        subAdd(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定添加该商品信息?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = this._serializeGood(this.obj);
                        addGood(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.tian = false;
                            this.obj = {
                                images: [],
                                cid: '',
                                title: '',
                                price: '',
                                intro: '',
                                seasonSpecs: [],
                                colors: [],
                                isPutaway: 1,
                                details: ''
                            };
                            this.tempColorInput = '';
                            this.cidPath = [];
                            this.fileList=[];
                            this.$message.success(msg);
                            this.getData();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        //搜索
        handleSearch() {
            this.lod = true;
            this.page = 1;
            this.total = 0;
            this.getData();
        },
        //修改
        handleUp(index, row) {
            let obj = JSON.stringify(row);
            obj = JSON.parse(obj)
            obj.images = JSON.parse(obj.images);
            // 解析季节规格和颜色
            try {
                obj.seasonSpecs = obj.seasonSpecs ? JSON.parse(obj.seasonSpecs) : [];
            } catch(e) { obj.seasonSpecs = []; }
            try {
                obj.colors = obj.colors ? JSON.parse(obj.colors) : [];
            } catch(e) { obj.colors = []; }
            this.upObj = obj;
            // 根据 cid 回填级联选择器路径
            const cid = obj.cid;
            const list = this.classifys || [];
            const child = list.find(c => c.cid === cid);
            if (child && child.parentId) {
                this.upCidPath = [child.parentId, cid];
            } else {
                this.upCidPath = [cid];
            }
            // 使用后端返回的签名 imgList 作为预览 URL，默认与 obj.images 索引一致
            const signedList = Array.isArray(row.imgList) ? row.imgList : [];
            let previewList = [];
            for (let i = 0; i < obj.images.length; i++) {
                previewList.push({ url: signedList[i] || '' });
            }
            this.fileListU = previewList;
            this.upg = true;
        },
        //删除指定商品
        handleDe(index, row) {
            this.$confirm("此操作将永久删除该商品信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteByGood({ gid: row.gid, cid: row.cid }).then((res) => {
                    if (res.code != 0) {
                        this.$message.error('删除失败');
                        return false;
                    }
                    this.$notify.success({
                        title: "系统提示",
                        message: "删除该商品成功",
                        showClose: false,
                    });
                    this.loading = true
                    this.tableData = this.tableData.filter((todo) => {
                        return todo.gid != row.gid;
                    })
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            });
        },
        //商品列表切换页数
        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },
        async getClassify() {
            let res = await queryClassifys()
            let { code, data } = res;
            if (code != 0) {
                this.$message.error('出现错误');
                return false;
            }
            this.classifys = data;
        },
        async getData() {
            try {
                this.loading = true;
                let pageNum = this.page;
                let pageSize = this.size;
                let res = null;
                let title = this.title;
                if (title) {
                    res = await querySearchGoods({ pageNum, pageSize, title });
                    setTimeout(() => {
                        this.lod = false;
                    }, 300);
                } else {
                    res = await queryGoods({ pageNum, pageSize });
                }
                this.tableData = res.list;
                this.total = res.total;
                setTimeout(() => {
                    this.loading = false;
                }, 500)
            } catch (error) {
                console.log(error);
                this.$message.error('服务器错误');
            }
        }
    },
    created() {
        this.url = this.$base.url;
        this.getData();
        this.getClassify();
    },

};
</script>

<style scoped>
.good-page {
    height: calc(100vh - 110px);
    overflow-y: auto;
}

.pp {
    margin-top: 10px;
    float: right;
    color: #909399;
}

.handle-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.handle-box-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.search-input {
    width: 220px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 60px;
    height: 60px;
}

.avatar-uploader {
    width: 100px;
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    cursor: pointer;
}

.avatar-uploader-icon {
    font-size: 30px;
    color: #8c939d;
}

.avatar {
    width: 100%;
    height: 100%;
}

/* 手机端适配 */
@media (max-width: 767px) {
  .good-page {
    height: calc(100vh - 56px);
  }
  .handle-box-left {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
  .search-input {
    width: 100%;
  }
}

/* 平板端适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .good-page {
    height: calc(100vh - 56px);
  }
  .search-input {
    width: 180px;
  }
}
</style>